// Mobile Nav
var hamburger = document.getElementById('hamburger');
var mobileMenu = document.getElementById('mobileMenu');

if (hamburger && mobileMenu) {
  hamburger.addEventListener('click', function() {
    hamburger.classList.toggle('open');
    mobileMenu.classList.toggle('open');
    document.body.style.overflow = mobileMenu.classList.contains('open') ? 'hidden' : '';
  });
}

function closeMenu() {
  if (hamburger && mobileMenu) {
    hamburger.classList.remove('open');
    mobileMenu.classList.remove('open');
    document.body.style.overflow = '';
  }
}

// Add to Cart via Shopify AJAX API
document.addEventListener('DOMContentLoaded', function() {
  var addToCartBtns = document.querySelectorAll('[data-add-to-cart]');

  addToCartBtns.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();

      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      var originalText = btn.textContent;
      btn.textContent = 'Adding...';
      btn.classList.add('loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      })
      .then(function(res) {
        if (!res.ok) throw new Error('Cart add failed');
        return res.json();
      })
      .then(function() {
        btn.textContent = 'Added to Cart \u2713';
        btn.classList.remove('loading');
        btn.classList.add('added');
        updateCartCount();
        setTimeout(function() {
          btn.textContent = originalText;
          btn.classList.remove('added');
        }, 2500);
      })
      .catch(function(err) {
        console.error('Add to cart error:', err);
        btn.textContent = 'Error - Try Again';
        btn.classList.remove('loading');
        setTimeout(function() {
          btn.textContent = originalText;
        }, 2000);
      });
    });
  });
});

// Cart count update
function updateCartCount() {
  fetch('/cart.js')
    .then(function(res) { return res.json(); })
    .then(function(cart) {
      var countEls = document.querySelectorAll('[data-cart-count]');
      countEls.forEach(function(el) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'inline' : 'none';
      });
    })
    .catch(function() {});
}

updateCartCount();
